package haxe.ui.themes;

class Theme {
    public var parent:String;
    public var styles:Array<String>;

    public function new() {
        styles = [];
    }
}